import { render, staticRenderFns } from "./tip2.vue?vue&type=template&id=39e829b0&"
import script from "./tip2.vue?vue&type=script&lang=js&"
export * from "./tip2.vue?vue&type=script&lang=js&"
import style0 from "./tip2.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgIcon: require('/builds/master/frontend/frontend-universe/components/SvgIcon.vue').default})
